import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';

export function useRequestReasons() {
  const {
    data: reasons,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['questionReasons'],
    queryFn: async () => {
      const response =
        await apiCancellationFunnels.tryToRequestQuestionReasons();
      return response.data;
    },
  });

  useEffect(() => {
    if (error) {
      OpenNotification(
        true,
        'Erro ao solicitar motivos das Perguntas',
        'Ocorreu um erro ao solicitar motivos das Perguntas, por favor tente novamente mais tarde.'
      );
    }
  }, [error]);

  return { reasons: reasons || [], isLoading };
}
